import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OffCanvasService {
	private isOpen = new BehaviorSubject<boolean>(false);

	constructor() {}

	open() {
		this.isOpen.next(true);
	}

	close() {
		this.isOpen.next(false);
	}

	getState() {
		return this.isOpen.asObservable();
	}

	get state() {
		return this.isOpen.value;
	}
}
